/** Which currency a new electricity price starts in. */

const BY_COUNTRY: Record<string, string> = { US: "USD", CA: "CAD", GB: "GBP", AU: "AUD", MX: "MXN" };

/** The currency of a country (ISO 3166-1 alpha-2); EUR for the rest. */
export function currencyOf(country: string | null | undefined): string {
  return BY_COUNTRY[(country ?? "").toUpperCase()] ?? "EUR";
}

type Company = { currency?: string | null; country?: string | null; default_jurisdiction?: string | null } | null | undefined;

/** A new price's currency: the utility's country's; for "every customer" (no utility) the company's currency, else
 * its country's (or its jurisdiction's country), so a US company starts in USD, never in EUR. */
export function priceCurrency(utilityCountry: string | null | undefined, company: Company): string {
  if (utilityCountry) return currencyOf(utilityCountry);
  if (company?.currency) return company.currency.toUpperCase();
  const country = company?.country || company?.default_jurisdiction?.split("-")[0];
  return country ? currencyOf(country) : "USD";
}

type PricedQuote = { currency?: string | null; tariff?: { currency?: string | null } | null } | null | undefined;

/** The currency of a saved quote priced for another region (its prices in another currency than the house is priced
 * in today, `Design.pricing_currency`, or its tariff in another currency than its prices), else null: the design page
 * then shows it as that saved quote, never as the design's price (the editor, Savings and Options price it again). */
export function otherRegionCurrency(quote: PricedQuote, pricingCurrency: string | null | undefined): string | null {
  const currency = quote?.currency?.toUpperCase();
  const today = pricingCurrency?.toUpperCase();
  if (!currency || !today) return null;
  const tariff = quote?.tariff?.currency?.toUpperCase();
  return currency !== today || (tariff && tariff !== currency) ? currency : null;
}
